module.exports = __webpack_public_path__ + "img/nomination_form.1fefb56f.svg";